// extracted by mini-css-extract-plugin
export default {"icon_button":"Buttons_icon_button__296Ys"};